/** Detect Accounts API geofence denial (403 / GEOFENCE_DENIED). */
export function isGeofenceDeniedError(err: unknown): boolean {
  const anyErr = err as {
    status?: number;
    error?:
      | string
      | {
          code?: string;
          message?: string | { message?: string };
        };
  };

  const status = anyErr?.status;
  const body = anyErr?.error;

  if (body && typeof body === "object") {
    if (body.code === "GEOFENCE_DENIED") {
      return true;
    }
    const message = coerceMessage(body.message);
    if (isGeofenceDeniedMessage(message)) {
      return true;
    }
  }

  const wrapped = (err as { error?: { code?: string; message?: string } })
    ?.error;
  if (wrapped?.code === "GEOFENCE_DENIED") {
    return true;
  }
  if (isGeofenceDeniedMessage(wrapped?.message)) {
    return true;
  }

  if (status === 403 && typeof body === "string" && isGeofenceDeniedMessage(body)) {
    return true;
  }

  return false;
}

function coerceMessage(value: unknown): string | null {
  if (typeof value === "string" && value.trim()) {
    return value.trim();
  }
  if (value && typeof value === "object") {
    const nested = (value as { message?: string }).message;
    if (typeof nested === "string" && nested.trim()) {
      return nested.trim();
    }
  }
  return null;
}

function isGeofenceDeniedMessage(message: string | null | undefined): boolean {
  if (!message) {
    return false;
  }
  return /not available (?:from your region|in your location)|geofence_denied/i.test(
    message
  );
}
